import { render } from "./AssinaturaResponsaveis.vue?vue&type=template&id=548e827f&scoped=true"
import script from "./AssinaturaResponsaveis.vue?vue&type=script&lang=js"
export * from "./AssinaturaResponsaveis.vue?vue&type=script&lang=js"

import "./AssinaturaResponsaveis.vue?vue&type=style&index=0&id=548e827f&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-548e827f"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput,QSelect,QTooltip});
